import * as React from "react";
import {useRef, useState} from "react";
import "./BeforeClientStartJoin.css";
import {useTranslation} from "react-i18next";
import {makeLink} from "../../../common/languages-helper";
import YellowButton from "../../../common/buttons/YellowButton";
import DeviceCheck, {DeviceCheckHandle} from "./DeviceCheck";

interface VisitorSessionProps {
    sessionId: string;
}
const BeforeClientStartJoin: React.FC<VisitorSessionProps> = ({sessionId}) => {
    const {t} = useTranslation();
    const [sessionOpened, setSessionOpened] = useState<boolean>(false);
    const deviceCheckRef = useRef<DeviceCheckHandle>(null);

    const handleStartSession = (sessionId: string) => {
        // Release the preview camera/mic so the session window can acquire them.
        deviceCheckRef.current?.stop();
        /* eslint-disable no-restricted-globals */
        window.open(makeLink("/csession-") + sessionId, "therapy-session", `
            directories=0,titlebar=0,toolbar=0,location=0,status=0,
            menubar=0,scrollbars=no,resizable=no,
            width=${screen.width},height=350`);
        setSessionOpened(true);
    }

    // Once the session is open in its own window, the preflight/onboarding is
    // just clutter — collapse to a compact "opened / reconnect" state.
    if (sessionOpened) {
        return <div className={"join-preflight"}>
            <h2 className={"join-preflight-title"}>{t("Opened session in new window")}</h2>
            <p className={"join-preflight-sub"}>
                {t("If you closed the session window, you can reopen it below.")}
            </p>
            <div className={"join-session-button-container"}>
                <YellowButton
                    variant="contained"
                    onClick={() => {handleStartSession(sessionId)}}
                >
                    {t("Reconnect to session")}
                </YellowButton>
            </div>
        </div>
    }

    return <div className={"join-preflight"}>
        <h2 className={"join-preflight-title"}>{t("Before you join")}</h2>
        <p className={"join-preflight-sub"}>
            {t("Check that your camera and microphone work — the therapist may use video during the session.")}
        </p>

        <DeviceCheck ref={deviceCheckRef} />

        <div className={"join-session-button-container"}>
            <YellowButton
                variant="contained"
                onClick={() => {handleStartSession(sessionId)}}
            >
                {t("Join Session")}
            </YellowButton>
            <p className={"join-preflight-skip"}>
                {t("You can join without camera or microphone.")}
            </p>
        </div>
    </div>
}
export default BeforeClientStartJoin;
